import { FC, HTMLProps } from 'react';

export const NotStonksIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      {...props}
    >
      <path
        d="M17.4 21L19.919 18.3283L14.551 12.635L10.151 17.3017L2 8.645L3.551 7L10.151 14L14.551 9.33333L21.481 16.6717L24 14V21H17.4Z"
        fill="#F93C65"
      />
    </svg>
  );
};
